import { UncertainInfo} from "./disposalSlice";
import moment, {Moment} from "moment";

export const isMockActive = (): boolean => process.env.REACT_APP_USE_MOCK_DATA === "true";

export const isUncertainInfoEmpty = (input: UncertainInfo | undefined): boolean => (
    !input || (input && (!input.value && !input.unknown))
);

export const nextWorkDayInRange = (range: number): Moment => {

    let result = moment().add(range, "days");

    while(result.weekday() === 0 || result.weekday() === 6) {
        result = moment(result).add(1, "days");
    }
    return result;
};
